<template>
  <v-container style="max-width:100vw;">
    <v-card class="elevation-0 pa-6">
      <v-row class="mt-0 mb-6 mx-4" align="center">
        <div style="width:60%; position:relative;">
          <v-text-field
            outlined
            dense
            hide-details
            rounded
            v-model="searchItems"
            @focus="showlist = true"
            @input="debouncedSearchItems"
            :loading="isLoadingItems"
            label="Producto"
            placeholder="Escribe para buscar"
          />

          <v-list
            v-if="searchItems && !isLoadingItems && itemsList.length > 0 && showlist"
            class="py-0"
            style="position:absolute;left:0;right:0;z-index:999;max-height:130px;overflow-y:auto;box-shadow:0 0 2px 0 #0000004a;cursor:pointer;background:white;"
          >
            <v-list-item
              v-for="p in itemsList"
              :key="p.id"
              style="border-bottom:1px solid #00000021;"
              class="item-hover"
              @click="selectProduct(p), showlist = false"
            >
              {{ p.name }}
            </v-list-item>
          </v-list>

          <v-list
            v-else-if="searchItems && !isLoadingItems && showlist"
            class="py-0"
            style="position:absolute;left:0;right:0;z-index:999;max-height:130px;box-shadow:0 0 2px 0 #0000004a;cursor:pointer;background:white;"
          >
            <v-list-item
              style="border-bottom:1px solid #00000021;"
              class="item-hover"
              @click="newProduct = searchItems"
            >
              No existen productos relacionados.
            </v-list-item>
          </v-list>
        </div>

        <v-row
          class="my-0 mx-8"
          v-if="product.provider && product.provider.id"
          align="center"
          no-gutters
        >
          <div class="pt-2 mr-2">Proveedor Actual:</div>
          <v-chip
            :to="{ path: '/providers/' + product.provider.id }"
            small
            class="mt-2"
            color="#e4e4e4"
            style="font-weight:500;"
          >
            {{ product.provider.name }}
          </v-chip>
          <v-icon
            small
            class="ml-2"
            @click="product.provider = null"
            style="cursor:pointer;"
          >
            mdi-pencil
          </v-icon>
        </v-row>

        <v-autocomplete
          outlined
          dense
          hide-details
          rounded
          class="mx-8"
          v-else
          :items="providers"
          :search-input.sync="createProvider.name"
          label="Proveedor"
          item-text="name"
          item-value="id"
          v-model="provider_id"
        >
          <template v-slot:no-data>
            <div class="px-6 pt-3">
              No existen proveedores relacionados.
              <v-text-field
                v-model="createProvider.name"
                label="Crear Proveedor"
                append-icon="mdi-plus"
                @click:append="saveProvider"
              />
            </div>
          </template>
        </v-autocomplete>

        <v-btn
          class="elevation-0 ml-auto"
          color="primary"
          rounded
          @click="onSave"
        >
          GUARDAR
        </v-btn>
      </v-row>

      <v-row class="ma-0">
        <v-col cols="6">
          <v-row class="ma-0 justify-center" style="border:1px solid #4a4a4a;">
            <v-col cols="4" class="px-0">
              <div class="tabla header-empty"></div>
              <div class="tabla cell-label">
                <span>{{ price1Label }}</span>
              </div>
              <div class="tabla cell-label">
                <span>PRECIO 2</span>
              </div>
              <div class="tabla cell-label">
                <span>PRECIO 3</span>
              </div>
              <div class="tabla cell-label">
                <span>{{ price4Label }}</span>
              </div>
            </v-col>

            <v-col cols="4" class="px-0">
              <div class="tabla header-mode">
                <v-checkbox
                  style="margin:auto;font-weight:500;"
                  :hide-details="true"
                  :input-value="editMode === 'sin_iva'"
                  label="SIN IVA"
                  @change="setEditMode('sin_iva')"
                />
              </div>

              <div class="tabla cell-value">
                <PriceCell
                  :editMode="editMode"
                  columnMode="sin_iva"
                  :value="draft.price"
                  @input="onEditPriceNoIva('1', $event)"
                />
              </div>
              <div class="tabla cell-value">
                <PriceCell
                  :editMode="editMode"
                  columnMode="sin_iva"
                  :value="draft.price_two"
                  @input="onEditPriceNoIva('2', $event)"
                />
              </div>
              <div class="tabla cell-value">
                <PriceCell
                  :editMode="editMode"
                  columnMode="sin_iva"
                  :value="draft.price_three"
                  @input="onEditPriceNoIva('3', $event)"
                />
              </div>
              <div class="tabla cell-value">
                <PriceCell
                  :editMode="editMode"
                  columnMode="sin_iva"
                  :value="draft.price_four"
                  @input="onEditPriceNoIva('4', $event)"
                />
              </div>
            </v-col>

            <v-col cols="4" class="px-0">
              <div class="tabla header-mode">
                <v-checkbox
                  style="margin:auto;font-weight:500;"
                  :hide-details="true"
                  :input-value="editMode === 'con_iva'"
                  label="CON IVA"
                  @change="setEditMode('con_iva')"
                />
              </div>

              <div class="tabla cell-value">
                <PriceCell
                  :editMode="editMode"
                  columnMode="con_iva"
                  :value="draft.price_iva"
                  @input="onEditPriceIva('1', $event)"
                />
              </div>
              <div class="tabla cell-value">
                <PriceCell
                  :editMode="editMode"
                  columnMode="con_iva"
                  :value="draft.price_two_iva"
                  @input="onEditPriceIva('2', $event)"
                />
              </div>
              <div class="tabla cell-value">
                <PriceCell
                  :editMode="editMode"
                  columnMode="con_iva"
                  :value="draft.price_three_iva"
                  @input="onEditPriceIva('3', $event)"
                />
              </div>
              <div class="tabla cell-value">
                <PriceCell
                  :editMode="editMode"
                  columnMode="con_iva"
                  :value="draft.price_four_iva"
                  @input="onEditPriceIva('4', $event)"
                />
              </div>
            </v-col>
          </v-row>
        </v-col>

        <v-col cols="6">
          <v-row class="ma-0" style="border:1px solid #4a4a4a;">
            <v-col cols="5" class="pa-0">
              <div class="tabla header-mode">
                <div style="margin:auto;">
                  <span style="font-weight:500;">COSTO (sin IVA)</span>
                </div>
              </div>
              <div class="tabla" style="height:360px!important;background:#fff;">
                <v-text-field
                  outlined
                  hide-details
                  rounded
                  style="margin:auto;"
                  prefix="$"
                  class="mx-6"
                  v-model="draft.current_cost_input"
                  @blur="onEditCost"
                />
              </div>
            </v-col>

            <v-col cols="7" class="pa-0">
              <div class="tabla header-mode">
                <div style="margin:auto;display:flex;align-items:center;gap:8px;">
                  <span style="font-weight:500;">UTILIDAD</span>
                  <v-icon
                    small
                    @click="setEditMode('utilidad')"
                    style="cursor:pointer;"
                  >
                    mdi-pencil
                  </v-icon>
                </div>
              </div>

              <div class="tabla cell-value">
                <UtilityCell
                  tier="1"
                  :editMode="editMode"
                  :price="draft.price"
                  :priceIva="draft.price_iva"
                  :currentCost="draft.current_cost"
                  :profitMargin="draft.profit_margin_1"
                  @update:profit-margin="val => onEditProfit('1', val)"
                />
              </div>

              <div class="tabla cell-value">
                <UtilityCell
                  tier="2"
                  :editMode="editMode"
                  :price="draft.price_two"
                  :priceIva="draft.price_two_iva"
                  :currentCost="draft.current_cost"
                  :profitMargin="draft.profit_margin_2"
                  @update:profit-margin="val => onEditProfit('2', val)"
                />
              </div>

              <div class="tabla cell-value">
                <UtilityCell
                  tier="3"
                  :editMode="editMode"
                  :price="draft.price_three"
                  :priceIva="draft.price_three_iva"
                  :currentCost="draft.current_cost"
                  :profitMargin="draft.profit_margin_3"
                  @update:profit-margin="val => onEditProfit('3', val)"
                />
              </div>

              <div class="tabla cell-value">
                <UtilityCell
                  tier="4"
                  :editMode="editMode"
                  :price="draft.price_four"
                  :priceIva="draft.price_four_iva"
                  :currentCost="draft.current_cost"
                  :profitMargin="draft.profit_margin_4"
                  @update:profit-margin="val => onEditProfit('4', val)"
                />
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-data-table
        sort-by="shopping.date"
        :sort-desc="true"
        v-if="product.item_shopping_details && product.item_shopping_details.length"
        class="pa-4"
        :items="product.item_shopping_details"
        :headers="header"
        :loading="isLoadingItems"
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title>Historial de Compras</v-toolbar-title>
          </v-toolbar>
        </template>

        <template v-slot:no-data>
          No existen registros de compras para este producto
        </template>

        <template v-slot:[`item.shopping.provider`]="{ item }">
          <v-list-item
            v-if="item && item.shopping && item.shopping.provider"
            class="px-0"
            style="min-height:0px;font-size:14px;"
            :to="{ path: '/providers/' + item.shopping.provider.id }"
          >
            {{ item.shopping.provider.name }}
          </v-list-item>
        </template>

        <template v-slot:[`item.shopping.id`]="{ item }">
          <v-list-item
            v-if="item && item.shopping"
            class="px-0"
            style="min-height:0px;font-size:14px;"
            :to="{ path: '/shoppings/' + item.shopping.id }"
          >
            {{ item.shopping.id }}
          </v-list-item>
        </template>

        <template v-slot:[`item.unit_cost`]="{ item }">
          {{ currency(item.unit_cost) }}
        </template>

        <template v-slot:[`item.total`]="{ item }">
          {{ currency(item.unit_cost * item.quantity) }}
        </template>
      </v-data-table>
    </v-card>

    <v-snackbar :color="snackbar.color" v-model="snackbar.show">
      {{ snackbar.message }}
    </v-snackbar>
  </v-container>
</template>

<script>
import debounce from 'lodash.debounce'
import axios from 'axios'
import PriceCell from './PriceCell.vue'
import UtilityCell from './UtilityCell.vue'
import { priceWithIva, priceWithoutIva } from './pricing'


export default {
  name: 'ProductPricingModule',
  components: {
    PriceCell,
    UtilityCell
  },
  data() {
    return {
      showlist: true,
      debouncedSearchItems: null,
      itemsList: [],
      isLoadingItems: false,
      searchItems: '',
      snackbar: {
        show: false,
        message: null,
        color: null
      },
      provider_id: '',
      newProduct: '',
      product_id: '',
      editMode: 'sin_iva',
      product: {
        id: '',
        name: '',
        code_one: '',
        code_two: '',
        code_three: '',
        provider: null,
        item_shopping_details: [],
        current_cost: 0,
        current_cost_input: '',
        price: 0,
        price_two: 0,
        price_three: 0,
        price_four: 0,
        price_iva: 0,
        price_two_iva: 0,
        price_three_iva: 0,
        price_four_iva: 0,
        profit_margin_1: 0,
        profit_margin_2: 0,
        profit_margin_3: 0,
        profit_margin_4: 0
      },
      draft: {
        current_cost: 0,
        price: 0,
        price_two: 0,
        price_three: 0,
        price_four: 0,
        price_iva: 0,
        price_two_iva: 0,
        price_three_iva: 0,
        price_four_iva: 0,
        profit_margin_1: 0,
        profit_margin_2: 0,
        profit_margin_3: 0,
        profit_margin_4: 0
      },
      entries: {
        products: []
      },
      createProvider: {
        name: ''
      }
    }
  },
  computed: {
    backendBase() {
      return process.env.VUE_APP_BACKEND_ROUTE
    },
    header() {
      return [
        { text: 'Fecha', value: 'shopping.date' },
        { text: 'Cantidad', value: 'quantity' },
        { text: 'Costo Unitario', value: 'unit_cost' },
        { text: 'Total', value: 'total' },
        { text: 'Proveedor', value: 'shopping.provider' },
        { text: 'Compra', value: 'shopping.id' }
      ]
    },
    providers() {
      return this.$store.state.provider.providers
    },
    price1Label() {
      return this.backendBase == 'https://backend.ferreteriaenlinea.com/'
        ? 'Precio Mayoreo'
        : 'PRECIO 1'
    },
    price4Label() {
      return this.backendBase == 'https://backend.ferreteriaenlinea.com/'
        ? 'Precio Mostrador'
        : 'PRECIO 4'
    }
  },
  watch: {
    product_id(val) {
      const found = this.entries.products.find(p => p.id === val)
      if (!found) return
      this.loadProduct(found)
    }
  },
  created() {
    this.debouncedSearchItems = debounce(this.fetchItemsList, 500)
  },
  methods: {
    setEditMode(mode) {
      this.editMode = mode
    },
    currency(v) {
      const n = parseFloat(v || 0)
      return n.toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })
    },
    normalizeNumber(v) {
      const n = parseFloat(v)
      if (isNaN(n)) return 0
      return n
    },
    baseStateFromApi(item) {
      const current_cost = this.normalizeNumber(item.current_cost)
      const price = this.normalizeNumber(item.price)
      const price_two = this.normalizeNumber(item.price_two)
      const price_three = this.normalizeNumber(item.price_three)
      const price_four = this.normalizeNumber(item.price_four)

      const price_iva = priceWithIva(price)
      const price_two_iva = priceWithIva(price_two)
      const price_three_iva = priceWithIva(price_three)
      const price_four_iva = priceWithIva(price_four)

      return {
        id: item.id,
        name: item.name,
        code_one: item.code_one,
        code_two: item.code_two,
        code_three: item.code_three,
        provider: item.provider || (item.latestShopping && item.latestShopping.shopping ? item.latestShopping.shopping.provider : null),
        item_shopping_details: item.item_shopping_details || [],
        current_cost,
        price,
        price_two,
        price_three,
        price_four,
        price_iva: this.normalizeNumber(price_iva),
        price_two_iva: this.normalizeNumber(price_two_iva),
        price_three_iva: this.normalizeNumber(price_three_iva),
        price_four_iva: this.normalizeNumber(price_four_iva),
        profit_margin_1: this.normalizeNumber(item.profit_margin_1),
        profit_margin_2: this.normalizeNumber(item.profit_margin_2),
        profit_margin_3: this.normalizeNumber(item.profit_margin_3),
        profit_margin_4: this.normalizeNumber(item.profit_margin_4)
      }
    },
    loadProduct(rawItem) {
      const mapped = this.baseStateFromApi(rawItem)
      this.product = { ...mapped }
      this.draft = { ...mapped,
        current_cost_input: mapped.current_cost !== null ? String(mapped.current_cost.toFixed(2)) : ''
      }
      this.searchItems = mapped.name
      this.showlist = false
      this.editMode = 'sin_iva'
    },
    selectProduct(p) {
      this.product_id = p.id
      this.loadProduct(p)
    },
    fetchItemsList() {
      if (!this.searchItems) {
        this.itemsList = []
        return
      }
      this.isLoadingItems = true
      const term = this.searchItems.trim()
      axios
        .get(
          this.backendBase +
            'api/v2/item/pos?filter[pos]=' +
            term +
            '&itemsPerPage=15'
        )
        .then(res => {
          const data = res.data.data || []
          this.entries.products = data
          this.itemsList = data
        })
        .finally(() => {
          this.isLoadingItems = false
        })
    },
    onEditPriceNoIva(tier, val) {
      const clean = this.normalizeNumber(val)
      if (tier === '1') {
        this.draft.price = clean
        this.draft.price_iva = priceWithIva(clean)
        this.draft.profit_margin_1 = this.calcMarginPct(clean)
      }
      if (tier === '2') {
        this.draft.price_two = clean
        this.draft.price_two_iva = priceWithIva(clean)
        this.draft.profit_margin_2 = this.calcMarginPct(clean)
      }
      if (tier === '3') {
        this.draft.price_three = clean
        this.draft.price_three_iva = priceWithIva(clean)
        this.draft.profit_margin_3 = this.calcMarginPct(clean)
      }
      if (tier === '4') {
        this.draft.price_four = clean
        this.draft.price_four_iva = priceWithIva(clean)
        this.draft.profit_margin_4 = this.calcMarginPct(clean)
      }
    },
    onEditPriceIva(tier, val) {
      const clean = this.normalizeNumber(val)
      if (tier === '1') {
        this.draft.price_iva = clean
        this.draft.price = priceWithoutIva(clean)
        this.draft.profit_margin_1 = this.calcMarginPct(this.draft.price)
      }
      if (tier === '2') {
        this.draft.price_two_iva = clean
        this.draft.price_two = priceWithoutIva(clean)
        this.draft.profit_margin_2 = this.calcMarginPct(this.draft.price_two)
      }
      if (tier === '3') {
        this.draft.price_three_iva = clean
        this.draft.price_three = priceWithoutIva(clean)
        this.draft.profit_margin_3 = this.calcMarginPct(this.draft.price_three)
      }
      if (tier === '4') {
        this.draft.price_four_iva = clean
        this.draft.price_four = priceWithoutIva(clean)
        this.draft.profit_margin_4 = this.calcMarginPct(this.draft.price_four)
      }
    },
    calcMarginPct(priceNoIva) {
      const p = this.normalizeNumber(priceNoIva)
      const c = this.normalizeNumber(this.draft.current_cost)
      if (!c || c <= 0) return 0
      const utilidad = p - c
      return ((utilidad / c) * 100).toFixed(2)
    },
    onEditProfit(tier, val) {
      const pct = this.normalizeNumber(val)
      if (tier === '1') {
        this.draft.profit_margin_1 = pct
        this.applyMarginToTier('1', pct)
      }
      if (tier === '2') {
        this.draft.profit_margin_2 = pct
        this.applyMarginToTier('2', pct)
      }
      if (tier === '3') {
        this.draft.profit_margin_3 = pct
        this.applyMarginToTier('3', pct)
      }
      if (tier === '4') {
        this.draft.profit_margin_4 = pct
        this.applyMarginToTier('4', pct)
      }
    },
    applyMarginToTier(tier, pct) {
      const baseNum = this.priceFromMargin(pct)
      const withIva = priceWithIva(baseNum)

      if (tier === '1') {
        this.draft.price = baseNum
        this.draft.price_iva = withIva
      }
      if (tier === '2') {
        this.draft.price_two = baseNum
        this.draft.price_two_iva = withIva
      }
      if (tier === '3') {
        this.draft.price_three = baseNum
        this.draft.price_three_iva = withIva
      }
      if (tier === '4') {
        this.draft.price_four = baseNum
        this.draft.price_four_iva = withIva
      }
    },
    priceFromMargin(marginPct) {
      const pct = this.normalizeNumber(marginPct)
      const c = this.normalizeNumber(this.draft.current_cost)
      if (!c) return 0
      return (pct / 100) * c + c
    },
    onEditCost() {
      const clean = this.normalizeNumber(this.draft.current_cost_input)
      this.draft.current_cost = clean
      
      this.draft.current_cost_input = clean ? clean.toFixed(2) : ''

      this.draft.profit_margin_1 = this.calcMarginPct(this.draft.price)
      this.draft.profit_margin_2 = this.calcMarginPct(this.draft.price_two)
      this.draft.profit_margin_3 = this.calcMarginPct(this.draft.price_three)
      this.draft.profit_margin_4 = this.calcMarginPct(this.draft.price_four)
    },
    saveProvider() {
      axios
        .post(this.backendBase + 'api/v2/item/pos', {
          name: this.createProvider.name
        })
        .then(() => {
          this.$store.dispatch('provider/getProviders')
        })
    },
    onSave() {
      const provider_id =
        this.provider_id ||
        (this.product.provider && this.product.provider.id) ||
        null

      const payload = {
        code_one: this.product.code_one,
        code_two: this.product.code_two,
        code_three: this.product.code_three,
        price: this.draft.price,
        price_two: this.draft.price_two,
        price_three: this.draft.price_three,
        price_four: this.draft.price_four,
        provider_id,
        current_cost: this.draft.current_cost,
        profit_margin_1: this.draft.profit_margin_1,
        profit_margin_2: this.draft.profit_margin_2,
        profit_margin_3: this.draft.profit_margin_3,
        profit_margin_4: this.draft.profit_margin_4
      }

      if (this.product.id) {
        axios
          .patch(this.backendBase + 'api/v2/items/' + this.product.id, payload)
          .then(() => {
            this.snackbar = {
              message: 'Ajuste realizado con éxito',
              color: 'success',
              show: true
            }
            this.product = { ...this.product, ...this.draft }
          })
          .catch(() => {
            this.snackbar = {
              message: 'Error al realizar el ajuste, revisa los valores e intenta de nuevo',
              color: 'error',
              show: true
            }
          })
      } else {
        const newPayload = {
          name: this.newProduct,
          ...payload
        }
        axios
          .post(this.backendBase + 'api/v1/item/create', newPayload)
          .then(() => {
            this.snackbar = {
              message: 'Producto creado con éxito',
              color: 'success',
              show: true
            }
          })
          .catch(() => {
            this.snackbar = {
              message: 'Error al crear el producto',
              color: 'error',
              show: true
            }
          })
      }
    }
  }
}
</script>

<style scoped>
.tabla {
  border: 1px solid #4a4a4a !important;
  border-radius: 0 !important;
  min-height: 90px;
  display: flex !important;
  align-items: center;
  justify-content: center;
  text-align: center;
  background:#fff;
}

.header-mode {
  background:#d9e4ff;
  font-weight:500;
}

.header-empty {
  background:#fff;
}

.cell-label {
  background:#fff;
  font-weight:500;
}

.cell-value {
  background:#fff;
}
</style>
